<div
  #tooltip="matTooltip"
  (click)="tooltip.show()"
  class="flex justify-start items-center h-1 w-full bg-grey-9 rounded-full"
  matTooltip="{{ label() }}: {{ rateToDisplay() }}"
  matTooltipClass="varden-tooltip"
  matTooltipPosition="above"
>
  <div [ngStyle]="{'width.%': barWidthPercentage()}" class="rounded-full h-1 bg-duck-blue-2"></div>
</div>
